import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../constants/common'
import ButtonComponent, { BUTTON_HEIGHT_32 } from '../../../Button'
import { useSelectContext } from '../../../Select'

import * as styles from './ActionSelectControlButton.module.css'

import MoreVertical from '../../../../icons/more-vertical.svg'

function ActionSelectControlButton({
  Button = ButtonComponent.Flat,
  beforeIconProps: {
    Icon: BeforeIcon = MoreVertical,
    ...beforeIconProps
  } = EMPTY_OBJECT,
  className = styles.ActionSelectControlButton,
  height = BUTTON_HEIGHT_32,
  isGrey = true,
  ...restProps
}) {
  const { isOpen } = useSelectContext()

  const buttonClassName = classNames(className, {
    [styles.active]: isOpen,
  })

  return (
    <Button
      {...restProps}
      beforeIconProps={{ ...beforeIconProps, Icon: BeforeIcon }}
      className={buttonClassName}
      height={height}
      isGrey={isGrey}
    />
  )
}

export default ActionSelectControlButton
